import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IClearance, Clearance } from "@/models/clearance.entity";

export const ClearanceDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IClearance> {
  getIdentifier(entity: IClearance): string {
    return entity.id;
  }

  protected mapEntity(entity: IClearance): IClearance {
    return new Clearance(entity);
  }
})();
